import { apiClient } from '../../axios';
import {
  PostSocialAuthParams,
  PostSocialAuthResponse,
  PostSocialCreateParams,
  PostSocialCreateResponse,
} from './types';

export const postCreateBySocialApi = (params: PostSocialCreateParams) =>
  apiClient.post<PostSocialCreateResponse>('/v1/user/create-by-social', params);

export const postAuthBySocialApi = (params: PostSocialAuthParams) =>
  apiClient.post<PostSocialAuthResponse>('/v1/user/auth-by-social', params);
